export default "__VITE_ASSET__DhJJk876__"